// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Uobx","productName":"Table_productName__1-YG2"};